import { Layout, Dropdown, Avatar, Typography } from "antd";
import {
  LogoutOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { clearAuthData, getUser } from "../../utils/storage";
import logo from "../../assets/ezygo-logo.png";
import "./HeaderBar.css";

const { Header } = Layout;
const { Text } = Typography;

export default function HeaderBar() {
  const navigate = useNavigate();
  const user = getUser();

  const logout = () => {
    clearAuthData();
    navigate("/login");
  };

  const resetPassword = () => {
    navigate("/reset-password");
  };

  /* ── User display helpers ──────────────────────────── */
  const firstName = user?.firstName || "";
  const lastName = user?.lastName || "";
  const userName = firstName && lastName ? `${firstName} ${lastName}` : user?.name || "User";
  const userInitials = userName
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  /* ── Dropdown menu ─────────────────────────────────── */
  const menuItems = [
    {
      key: "reset",
      icon: <RedoOutlined />,
      label: "Reset Password",
      disabled: true,
      onClick: resetPassword,
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Log out",
      onClick: logout,
    },
  ];

  return (
    <Header className="app-header">
      {/* ── Left: Brand ──────────────────────────────── */}
      <div className="header-brand">
        <img src={logo} alt="EZYGO" className="header-brand-logo" />
        <div className="header-brand-info">
          <Text className="header-brand-title">EZYGO LOGISTICS</Text>
          <Text className="header-brand-subtitle">ADMIN CONSOLE</Text>
        </div>
      </div>

      {/* ── Right: Actions ───────────────────────────── */}
      <div className="header-actions">
        {/* Welcome text */}
        <div className="header-welcome">
          <Text className="header-welcome-name">
            Welcome, {userName}
          </Text>
          <Text className="header-welcome-time">
            Last login: {new Date().toLocaleTimeString()}
          </Text>
        </div>

        {/* User avatar with dropdown */}
        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          arrow
        >
          <Avatar size={40} className="header-avatar">
            {userInitials}
          </Avatar>
        </Dropdown>
      </div>
    </Header>
  );
}
